import {
  apiGenerator,
  toQueryString,
} from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { PersonalInfoAgreeGetResult } from '../../models/gen/personalInfoAgreeGetResult';
import { Worker } from '../../models/gen/worker';
import { WorkerGetResult } from '../../models/gen/workerGetResult';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const WORKER_CONTEXT_NAMES = {
  GET_WORKER: 'getWorker',
  POST_WORKER: 'saveWorker',
  POST_WORKER_PERSONAL_INFO_AGREE: 'agreePersonalInfo',
  GET_WORKER_PERSONAL_INFO_AGREE: 'getWorkerAgreePersonalInfo',
} as const;

const apis = apiGenerator();

type UseGetWorkerParam = { usercode?: string };

/**
 * GET /worker
 *
 * @param param -
 * @returns
 */
export const useGetWorker = (param?: UseGetWorkerParam) =>
  useGenericQuery(
    [WORKER_CONTEXT_NAMES.GET_WORKER, param],
    async (_param) =>
      apis.get<void, WorkerGetResult>(
        `${env.BASE_API_ENDPOINT}/worker${toQueryString(param)}`,
        { ...queryOptions }
      ),
    { enabled: false }
  );

/**
 * POST /worker
 *
 * @param param -
 * @returns
 */
export const usePostWorker = () =>
  useGenericMutation(async (param: Worker) =>
    apis.post(`${env.BASE_API_ENDPOINT}/worker`, {
      ...queryOptions,
      data: param,
    })
  );

/**
 * POST /worker/personal-info/agree
 *
 * @returns
 */
export const usePostWorkerPersonalInfoAgree = () =>
  useGenericMutation(async () =>
    apis.post(`${env.BASE_API_ENDPOINT}/worker/personal-info/agree`, {
      ...queryOptions,
    })
  );

/**
 * GET /worker/personal-info/agree
 *
 * @returns
 */
export const useGetWorkerPersonalInfoAgree = () =>
  useGenericQuery(
    [WORKER_CONTEXT_NAMES.GET_WORKER_PERSONAL_INFO_AGREE],
    async () =>
      apis.get<void, PersonalInfoAgreeGetResult>(
        `${env.BASE_API_ENDPOINT}/worker/personal-info/agree`,
        {
          ...queryOptions,
        }
      ),
    { enabled: false }
  );
